import { render } from "./TopOfsuccess.vue?vue&type=template&id=216fe0a4"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TopOfsuccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "216fe0a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('216fe0a4', __exports__)) {
    api.reload('216fe0a4', __exports__)
  }
  
  module.hot.accept("./TopOfsuccess.vue?vue&type=template&id=216fe0a4", () => {
    api.rerender('216fe0a4', render)
  })

}


export default __exports__